//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createFieldConfig } from '../../components/QSelectUtils'
import { axiosGet } from '../../axios/axios.js'

import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import ReportForkliftTruck from './ReportForkliftTruck/ReportForkliftTruck.vue'
import RequestYandexExecutorField from '../Request/RequestYandexExecutorField.vue'
import ReportBrigadePerformedTasks from './ReportBrigadePerformedTasks.vue'
import ReportContentSection from './ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportForkliftTruck,
    ItemsSearchField,
    RequestYandexExecutorField,
    ReportContentSection
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    vehicleHidden: {
      type: Boolean,
      defaultValue: false
    },
    addressHidden: {
      type: Boolean,
      defaultValue: false
    }
  },
  data: function () {
    return {
      selectedVehicles: [],
      vehiclesFieldConfig: createFieldConfig({ allRecordsFn: this.getVehicles })
    }
  },
  computed: {
    stocks: function () {
      const stocks = []
      if (this.report.availableStocks) {
        stocks.push(...this.report.availableStocks.map(stock => stock.name))
      }
      if (this.report.archiveStocks) {
        stocks.push(...this.report.archiveStocks.map(stock => stock.name + ' (архивный)'))
      }
      return stocks.join(', ')
    },
    vehicleShown: function () {
      return !this.vehicleHidden && !this.report.brigadeIsContractor
    },
    vehicleText: function () {
      if (this.report.gosNumber && this.report.garageNumber) {
        return `${this.report.gosNumber} (борт № ${this.report.garageNumber})`
      } else {
        return this.report.gosNumber || this.report.garageNumber || null
      }
    },
    vehicleLabel: function () {
      if (this.report.gosNumber && this.report.garageNumber) {
        return 'ТРАНСПОРТНОЕ СРЕДСТВО'
      } else if (this.report.garageNumber) {
        return 'БОРТОВОЙ НОМЕР ТРАНСПОРТНОГО СРЕДСТВА'
      } else if (this.report.gosNumber) {
        return 'ГРЗ ТРАНСПОРТНОГО СРЕДСТВА'
      }
      return 'ТРАНСПОРТНОЕ СРЕДСТВО'
    }
  },
  watch: {
    selectedVehicles: {
      handler: function (value) {
        this.report.selectedVehiclesSearchFormatted = value.map(ts => {
          return {
            id: ts.id,
            name: ts.name,
            gosNumber: ts['param.grz'],
            garageNumber: ts['param.garage']
          }
        })
      }
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.updateTextarea(this.$refs.address)
    })
    if (this.vehicleShown) {
      const numbers = this.report.gosNumber ? this.report.gosNumber.split(' / ') : []
      const garageNumbers = this.report.garageNumber ? this.report.garageNumber.split(' / ') : []
      if (numbers.length >= garageNumbers.length) {
        numbers.forEach(async (number, i) => {
          const args = [
            garageNumbers.length > 0 ? garageNumbers[i] : null,
            numbers.length > 0 ? numbers[i] : null
          ]
          const vehicle = (await this.getVehiclesInfo(...args))[0]
          this.selectedVehicles.push(vehicle)
        })
      } else {
        garageNumbers.forEach(async (number, i) => {
          const args = [
            garageNumbers.length > 0 ? garageNumbers[i] : null,
            numbers.length > 0 ? numbers[i] : null
          ]
          const vehicle = (await this.getVehiclesInfo(...args))[0]
          this.selectedVehicles.push(vehicle)
        })
      }
    }
  },
  methods: {
    openBrigadePerformedTasks: function () {
      const dialog = this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        contentComponent: ReportBrigadePerformedTasks,
        noWrap: true,
        contentProps: {
          report: this.report
        },
        componentHandlers: {
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    getVehicles: function () {
      const params = [
        { param: 'garage', type: 'string', action: 'any' },
        { param: 'grz', type: 'string', action: 'any' }
      ]
      return this.getPropertyValues('vehicle', params)
    },
    getVehiclesInfo: function (garageNumber, gosNumber) {
      const params = []
      if (garageNumber && gosNumber) {
        params.push({ param: 'grz', type: 'string', action: '=', value: gosNumber })
        params.push({ param: 'garage', type: 'string', action: 'any' })
      } else if (garageNumber) {
        params.push({ param: 'garage', type: 'string', action: '=', value: garageNumber })
        params.push({ param: 'grz', type: 'string', action: 'any' })
      } else {
        params.push({ param: 'grz', type: 'string', action: '=', value: gosNumber })
        params.push({ param: 'garage', type: 'string', action: 'any' })
      }
      return this.getPropertyValues('vehicle', params)
    },
    getPropertyValues: function (propertyKey, params) {
      const encodeParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodeParams + '&type=' + propertyKey + '&sort=name&limit=20000',
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },
    updateTextarea: function (cmp) {
      if (cmp) {
        const textarea = cmp.$el.querySelector('.q-field__native')
        textarea.style.height = textarea.scrollHeight + 'px'
      }
    },
    formatEmployee: function (employee, index = 0) {
      return (index === 0 ? '' : ', ') + employee.fio + (employee.phone ? ' (' + employee.phone + ')' : '')
    },
    validate: function (action) {
      return true
    },
    onUpdated: function () {
      this.$emit('updated')
    },
    getOptionLabel: function (scope) {
      let result = scope.opt.name
      const grzText = scope.opt['param.grz'] && (scope.opt['param.grz'] && !scope.opt.name.replaceAll(' ', '').includes(scope.opt['param.grz'])) ? `грз ${scope.opt['param.grz']}` : null
      const garageText = scope.opt['param.garage'] ? `борт №${scope.opt['param.garage']}` : null
      if (grzText || garageText) {
        result += ' ' + `(${[grzText, garageText].filter(Boolean).join(', ')})`
      }
      return result
    }
  }
}

